import { useSelector } from "react-redux";
import { Col, Spinner } from "react-bootstrap";
import { isEmpty } from "lodash";

import Icon from "./Icon";
import EmptyData from "./EmptyData";
import ErrorMessage from "./ErrorMessage";
import useUploadFile from "../hook/useUploadFile";
import { hostname } from "../services/configServices/config";
import { convertDate } from "../utils";

const DocumentsSection = ({ watch, setValue, register, errors }) => {
  const loader = useSelector((state) => state.loader);

  const { handleUploadFile } = useUploadFile();

  const handleAddItem = (type, value) => {
    const initialDocuments = {
      title: "",
      path: value,
    };

    switch (type) {
      case "documents":
        setValue(type, [...(watch(type) ?? []), initialDocuments]);
        break;

      default:
        break;
    }
  };
  const handleRemoveItem = (type, index) =>
    setValue(
      type,
      watch(type)?.filter((_, _i) => _i !== index)
    );

  return (
    <div className="col-12">
      <div className="mb-20">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <span className="form-label fw-semibold text-primary-light text-sm mb-8">
            مستندات
          </span>

          <label htmlFor="uploadFile" className="btn btn-outline-primary">
            <input
              disabled={loader}
              type="file"
              multiple
              accept=".jpg,.jpeg,.png,.gif,.docx,.xlsx,.csv,.pdf,.mp4,.avi;capture=camera"
              id="uploadFile"
              className="d-none"
              onChange={async (e) => {
                for (let i = 0; i < e.target.files?.length; i++) {
                  const file = e.target.files[i];
                  await handleUploadFile(
                    file,
                    (e) => handleAddItem("documents", e),
                    3
                  );
                }
                document.getElementById(`uploadFile`).value = "";
              }}
            />
            {loader ? (
              <Spinner size="sm" />
            ) : (
              <Icon
                icon="solar:upload-minimalistic-broken"
                className="text-2xxl"
              />
            )}
          </label>
        </div>

        {isEmpty(watch("documents")) ? (
          <EmptyData title="مستندی برای نمایش یافت نشد" />
        ) : (
          <div className="row g-2">
            {watch("documents")?.map((item, index) => (
              <Col xs="12" key={item}>
                <div className="input-group" dir="ltr">
                  <button
                    type="button"
                    className="btn btn-danger"
                    onClick={() => handleRemoveItem("documents", index)}
                  >
                    <Icon
                      icon="solar:trash-bin-minimalistic-broken"
                      className="text-xxl"
                    />
                  </button>
                  {item?.path && (
                    <a
                      href={`${hostname}${item?.path}`}
                      target="_blank"
                      without
                      rel="noreferrer"
                      className="btn btn-primary"
                      type="button"
                    >
                      <Icon icon="solar:eye-broken" className="text-xxl" />
                    </a>
                  )}

                  {item?.createdAt && (
                    <input
                      placeholder="تاریخ ایجاد"
                      className="form-control radius-8 text-end"
                      value={convertDate(item?.createdAt)}
                      disabled
                    />
                  )}
                  <input
                    type="text"
                    placeholder="عنوان مستند را وارد نمایید"
                    className="form-control radius-8 text-end"
                    {...register(`documents[${index}].title`)}
                  />
                </div>
                {errors.documents && (
                  <>
                    <ErrorMessage
                      message={errors.documents[index]?.title?.message}
                    />
                    <ErrorMessage
                      message={errors.documents[index]?.path?.message}
                    />
                  </>
                )}
              </Col>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default DocumentsSection;

export const DocumentsDetails = ({ documents }) => {
  if (isEmpty(documents)) return null;

  return (
    <>
      <br />
      <span className="text-primary border-bottom fw-bold">مستندات</span>
      <div className="row mt-1 g-2">
        {documents?.map((item) => (
          <Col sm="6" md="4">
            <a
              href={`${hostname}${item?.path}`}
              target="_blank"
              without
              rel="noreferrer"
              className="dropdown-item text-black p-8 border border-info-200 bg-info-50 bg-hover-info-100 radius-12 d-flex align-items-center justify-content-center"
              type="button"
            >
              {item?.title}
            </a>
          </Col>
        ))}
      </div>
    </>
  );
};
